export const getOperatorySchedule = "/operatory-media/schedule";
export const getWaitingRoomSchedule = "/operatory-media/schedule";
